import React from 'react'
import {FormattedMessage} from 'react-intl'
import {INews} from '../../../models/News'
import AmpLink, {AmpNavLink} from '../common/AmpLink'
import Breadcrumb from '../containers/Breadcrumb'
import BreadcrumbHome from '../containers/BreadcrumbHome'
import {IRouteComponentProps} from '../containers/DataResolver'
import {useLocale, useWebp} from '../hocs/hooks'
import NewsPreview from './NewsPreview'
import styles from './NewsPreview.scss'

const News = ({resolvedData: {news}}: IRouteComponentProps<{news: INews}>) => {
  const webp = useWebp()
  const locale = useLocale()
  const {title} = news
  return <>
    <div className={[webp && styles.webp].filter(Boolean).join(' ')}>
      <Breadcrumb>
        <BreadcrumbHome/>
        <AmpNavLink to={`/${locale}/company/`}>
          <FormattedMessage id="footer.aboutCompany"/>
        </AmpNavLink>
        {title}
      </Breadcrumb>
      <div className="container py-5">
        <NewsPreview news={news} />
        <div className="text-center pt-4">
          <AmpLink
            to={`/${locale}/company/`}
            className={['btn btn-outline-primary py-2', styles.orderButton].join(' ')}
          >
            <div className={['px-4 py-1', styles.buttonFont].join(' ')}>
              <FormattedMessage id="news.return" defaultMessage="Return news page" />
            </div>
          </AmpLink>
        </div>
      </div>
    </div>
  </>
}
News.displayName = 'News'
export default News
